export default __webpack_public_path__ + "9bc7a9d59e751b0084e64dcd800b1274.png";